import styled from 'styled-components';

interface StyledLazyImageProps {
  $isLoaded: boolean;
  $isCircle?: boolean;
}

export const StyledLazyImage = styled.img<StyledLazyImageProps>`
  opacity: ${(props) => (props.$isLoaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  border-radius: ${(props) => (props.$isCircle ? '50%' : '0')};
`;
